import { SolutionDetailTemplate } from '../shared/SolutionDetailTemplate';

export function BioinformaticsPage() {
  const keyFeatures = [
    "Advanced genomic sequence analysis with high accuracy variant calling",
    "3D protein structure prediction and drug-target interaction modeling",
    "AI-powered compound screening for accelerated drug discovery",
    "Seamless integration with clinical workflows and research pipelines",
    "Real-time biomarker identification and therapeutic target discovery",
    "Scalable cloud-based processing of massive biological datasets"
  ];

  const benefits = [
    "Accelerate drug discovery timelines by up to 40%",
    "Reduce research costs through automated analysis workflows",
    "Improve accuracy of genomic variant identification",
    "Enable precision medicine through personalized genomic insights",
    "Scale research capacity without increasing manual effort",
    "Integrate seamlessly with existing laboratory information systems"
  ];

  const useCases = [
    "Genomic variant analysis for rare disease research",
    "Drug target identification and validation in oncology",
    "Personalized medicine based on genetic profiles",
    "Protein folding prediction for therapeutic development",
    "Clinical trial patient stratification and biomarker discovery",
    "Agricultural genomics for crop improvement and disease resistance"
  ];

  const relatedTools = [
    {
      name: "Computer Vision",
      description: "AI-powered medical imaging analysis",
      href: "/solutions/computer-vision"
    },
    {
      name: "Predictive Maintenance",
      description: "Equipment monitoring for lab instruments",
      href: "/solutions/predictive-maintenance"
    }
  ];

  const industries = [
    "Pharmaceutical Research",
    "Biotechnology",
    "Healthcare & Medical Research",
    "Academic Research Institutions",
    "Agricultural Technology",
    "Clinical Diagnostics"
  ];

  return (
    <SolutionDetailTemplate
      title="Bioinformatics"
      description="Revolutionary AI-powered bioinformatics solutions that accelerate genomic research, drug discovery, and precision medicine initiatives through advanced computational analysis."
      category="Life Science Solutions"
      categoryColor="#0FFFA0"
      keyFeatures={keyFeatures}
      benefits={benefits}
      useCases={useCases}
      relatedTools={relatedTools}
      industries={industries}
    />
  );
}